import { FONT_SIZE, mq, COLOR, TextLink as _TextLink } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const SpanMandatory = styled.span`
  color: ${COLOR.RED900.code};
`;

export const AnchorUlTextLink = styled(_TextLink)`
  display: inline-block;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XXS}px;
  }
`;

export const UlNavList = styled.ul`
  list-style: disc;
  padding: 16px 16px 16px 32px;
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY500.code};

  ${mq.sp} {
    font-size: ${FONT_SIZE.XXS}px;
  }
`;
